import { useState } from "react";
import axios from "axios";

const PatentSection = () => {
  const [formData, setFormData] = useState({
    title: "",
    inventors: "",
    patentNumber: "",
    filingDate: "",
    status: "Filed",
    description: "",
    department: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://admin.stipsredu.in/patent/add",
        formData
      );

      alert("Patent added successfully!");

      // Reset form
      setFormData({
        title: "",
        inventors: "",
        patentNumber: "",
        filingDate: "",
        status: "Filed",
        description: "",
        department: ""
      });

    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Error adding patent");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Add Patent</h2>

      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded-xl shadow-md">

        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="inventors"
          placeholder="Inventors"
          value={formData.inventors}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="patentNumber"
          placeholder="Patent Number"
          value={formData.patentNumber}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="date"
          name="filingDate"
          value={formData.filingDate}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
        >
          <option value="Filed">Filed</option>
          <option value="Published">Published</option>
          <option value="Granted">Granted</option>
        </select>

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="department"
          placeholder="Department"
          value={formData.department}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <button
          type="submit"
          className="bg-red-600 text-white px-6 py-2 rounded-lg"
        >
          Add Patent
        </button>
      </form>
    </div>
  );
};

export default PatentSection;